import React, { useRef } from 'react';
import colors from 'styles/themes/colors';
import { ButtonBox, Caret, CaretSpan } from './shared/styles';
import Span from 'components/elements/span';
import { useFilterSize } from 'components/TopicFilters/utils/useFilterSize';
import { ReactComponent as ClearButton } from 'icons/icon-clear-button.svg';
import pluralize from 'helpers/pluralize';
import useMedia from 'hooks/useMedia';
interface IButtonProps {
  selectedItem: any;
  selectedItems?: any;
  isOpen?: boolean;
  disabled?: boolean;
  defaultLabel?: string;
  isDisplayedWithFlag?: boolean;
  dropdownType: 'Region' | 'Territory' | 'Timeframe';
  clearFilter?: () => void;
  withoutArrow?: boolean;
}

const DropdownButton: React.FC<IButtonProps> = (props) => {
  const {
    selectedItem,
    selectedItems,
    isOpen,
    disabled,
    defaultLabel,
    dropdownType,
    clearFilter,
    withoutArrow,
  } = props;

  const isSmallScreen: boolean = useMedia('(max-width: 47em)');

  const hasSelectedValue =
    (selectedItem || selectedItems?.length > 0) && selectedItem?.id !== 'WW';
  const boxColor = disabled
    ? colors.DisabledGrey
    : hasSelectedValue && !withoutArrow
    ? colors.White
    : colors.NightBlue;

  const ref = useRef(null);

  useFilterSize(ref);

  return (
    <ButtonBox
      py={1}
      px={2}
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      alignContent="stretch"
      color={isSmallScreen ? colors.NightBlue : boxColor}
      selected={hasSelectedValue && !withoutArrow}
    >
      {selectedItems?.length > 1 ? (
        <Span
          alignSelf="auto"
          marginRight="8px"
          fontWeight={600}
          style={{ whiteSpace: 'nowrap' }}
        >
          {`${pluralize(dropdownType, 2)} (${selectedItems.length})`}
        </Span>
      ) : (
        <Span alignSelf="auto" marginRight="8px" fontWeight={600} ref={ref}>
          {selectedItem
            ? selectedItem.label || selectedItem.displayName
            : defaultLabel}
        </Span>
      )}
      {!withoutArrow && (
        <CaretSpan>
          <Caret
            isPointingUp={isOpen}
            isSmall={!isSmallScreen}
            selected={hasSelectedValue}
            disabled={disabled}
          />
        </CaretSpan>
      )}

      {!!hasSelectedValue && clearFilter && !withoutArrow && !isSmallScreen && (
        <Span
          marginLeft="10px"
          alignSelf="auto"
          display="flex"
          onClick={(e): void => {
            e.preventDefault();
            e.stopPropagation();
            clearFilter();
          }}
        >
          <ClearButton />
        </Span>
      )}
    </ButtonBox>
  );
};

export default DropdownButton;
